<template>
  <details name="faq" class="group border-b border-pink">
    <summary
      class="font-title flex gap-20 cursor-pointer list-none items-center justify-between text-2xl md:text-3xl uppercase py-8 group-first-of-type:pt-0"
    >
      <span>
        {{ content.question }}
      </span>

      <span
        class="flex items-center justify-center cursor-pointer w-12.5 aspect-square rounded-full border border-pink shrink-0 transition-transform duration-300 group-open:rotate-180"
      >
        <IconSprite id="arrow" class="text-base rotate-90" />
      </span>
    </summary>

    <div class="overflow-hidden">
      <RawHtml
        :html="content.answer"
        class="pb-7 [&_p]:mb-4 [&_p:last-child]:mb-0 [&_a]:font-bold [&_a]:text-inherit! [&_a]:bg-transparent! [&_a]:transition-opacity [&_a:hover]:bg-transparent! [&_a:hover]:opacity-70 [&_ul]:mb-4 [&_ol]:mb-4"
      />

      <RouterLink
        v-if="hasButton && isInternalLink"
        :to="content.button_link"
        class="inline-flex items-center justify-center font-title uppercase border border-burgundy rounded-full px-6 py-3 mb-7 text-burgundy no-underline transition-colors duration-300 hover:bg-burgundy hover:text-white"
      >
        {{ content.button_label }}
      </RouterLink>

      <a
        v-else-if="hasButton"
        :href="content.button_link"
        target="_blank"
        rel="noopener noreferrer"
        class="inline-flex items-center justify-center font-title uppercase border border-burgundy rounded-full px-6 py-3 mb-7 text-burgundy no-underline transition-colors duration-300 hover:bg-burgundy hover:text-white"
      >
        {{ content.button_label }}
      </a>
    </div>
  </details>
</template>

<script lang="ts">
import IconSprite from '@/components/helpers/IconSprite.vue'
import RawHtml from '@/components/helpers/RawHtml.vue'

export default {
  name: 'FaqCard',

  components: {
    IconSprite,
    RawHtml,
  },

  props: {
    content: {
      type: Object,
      required: true,
    },
  },

  computed: {
    hasButton() {
      return Boolean(this.content.button_label && this.content.button_link)
    },

    isInternalLink() {
      return (
        typeof this.content.button_link === 'string' && this.content.button_link.startsWith('/')
      )
    },
  },
}
</script>
